var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMoreLess01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 360,
    stroke: "#D3D3D3",
    strokeWidth: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 400H640",
    stroke: "#D3D3D3",
    strokeWidth: 60,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMoreLess01);
export default __webpack_public_path__ + "static/media/ico_more_less_01.53a15b05b2a12e44738a8871fc9d19e1.svg";
export { ForwardRef as ReactComponent };